import { gql } from "@apollo/client";

export default gql`
  query getComplianceProgramLoadPreview(
    $organizationId: Int!
    $complianceProgramId: Int
    $steps: [ComplianceProgramStepInput]
    $assessmentTemplates: [AssessmentTemplateComplianceRequirement]
    $calibration: ComplianceProgramCalibrationType
    $ongoing: Boolean
    $startDateOffset: Int
    $appliesTo: ComplianceProgramAppliesTo
    $appliesToTeams: [Int]
    $appliesToManagers: [Int]
    $appliesToUsers: [Int]
    $excludedUsers: [Int]
    $excludedHireDateAfter: Date
    $removeExcludedHireDateAfter: Boolean
    $savedRoster: Boolean
  ) {
    complianceProgramLoadPreview(
      organizationId: $organizationId
      complianceProgramId: $complianceProgramId
      steps: $steps
      assessmentTemplates: $assessmentTemplates
      calibration: $calibration
      ongoing: $ongoing
      startDateOffset: $startDateOffset
      appliesTo: $appliesTo
      appliesToTeams: $appliesToTeams
      appliesToManagers: $appliesToManagers
      appliesToUsers: $appliesToUsers
      excludedUsers: $excludedUsers
      excludedHireDateAfter: $excludedHireDateAfter
      removeExcludedHireDateAfter: $removeExcludedHireDateAfter
      savedRoster: $savedRoster
    ) {
      questionsPerReview
      steps {
        step
        reviews
        questionsEach
        answers
      }
      writers {
        user {
          id
          name
          avatar
        }
        byStep {
          step
          reviews
        }
        reviews
        questions
      }
      totalReviews
      totalAnswers
      peerCountUnknown
      participantCount
      participantsWithoutRoleCount
      soleEditor {
        id
      }
      solePreCalibrationUnblocker {
        id
        name
      }
    }
  }
`;
